/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RandomNameResponse } from '../../models/random-name-response';

export interface PromptsRandomArtistTagGet$Params {}

export function promptsRandomArtistTagGet(
  http: HttpClient,
  rootUrl: string,
  params?: PromptsRandomArtistTagGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RandomNameResponse>> {
  const rb = new RequestBuilder(rootUrl, promptsRandomArtistTagGet.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RandomNameResponse>;
      }),
    );
}

promptsRandomArtistTagGet.PATH = '/prompts/randomArtistTag';
